export const CIRCLE_DELIVERY_AREA_TYPE = 'circle'

function validRadius(radius) {
    const value = Number(radius)

    return radius !== null && radius !== '' && value > 0 ? value : null
}

function formatKm(meters) {
    return String(parseFloat((meters / 1000).toFixed(3)))
}

/**
 * Name of a radius based delivery area: "<previous radius>-<radius> km",
 * where the previous radius is the largest smaller radius of the
 * restaurant's other areas (0 for the innermost one).
 * E.g. radiuses 1700 and 3000 give "0-1.7 km" and "1.7-3 km".
 */
export function circleDeliveryAreaName(radius, allRadiuses = []) {
    const current = validRadius(radius)

    if (current === null) return null

    const previous = allRadiuses
        .map(validRadius)
        .filter((value) => value !== null && value < current)
        .reduce((max, value) => Math.max(max, value), 0)

    return `${formatKm(previous)}-${formatKm(current)} km`
}
